import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { formatPct, formatTRY } from "@/lib/format";

const sel = "h-9 px-2 rounded-md border border-slate-200 bg-white text-sm";

export default function ExecuteDialog({ periods, initial, onClose, onDone }) {
  const [period, setPeriod] = useState(periods.find((p) => p.key === initial)?.key || periods[0].key);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (dry) => {
    setBusy(true);
    try {
      const { data } = await api.post("/prim/execute", { period, dry_run: dry });
      if (dry) setRes(data);
      else { toast.success(`${data.created.length} personel hesaplandı${data.skipped.length ? `, ${data.skipped.length} zaten hesaplı (atlandı)` : ""}`); onDone(period); }
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl" data-testid="prim-execute-dialog">
        <DialogHeader><DialogTitle>Prim Hesaplama – Şimdi Çalıştır</DialogTitle></DialogHeader>
        <p className="text-[12px] text-slate-500">Zamanlayıcı her gün personelin hesaplama gününde önceki takvim ayını bir kez hesaplar. Burada istediğiniz dönemi önce kaydetmeden simüle edebilir, ardından kaydedebilirsiniz (hesaplı personel atlanır).</p>
        <div className="flex gap-2 items-center">
          <select className={sel} value={period} onChange={(e) => { setPeriod(e.target.value); setRes(null); }} data-testid="prim-execute-period">
            {periods.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
          </select>
          <Button variant="outline" disabled={busy} onClick={() => run(true)} data-testid="prim-simulate-button">Simülasyon</Button>
          <Button disabled={busy} className="bg-blue-600 hover:bg-blue-700" onClick={() => run(false)} data-testid="prim-run-save-button">Hesapla ve Kaydet</Button>
        </div>
        {res && (
          <div className="overflow-x-auto"><table className="erp-table" data-testid="prim-simulation-table">
            <thead><tr><th>Personel</th><th>Sistem</th><th className="text-right">Prime Esas</th><th className="text-right">Marj</th><th className="text-right">Satır Primi</th><th className="text-right">Düzeltme</th><th className="text-right">Toplam</th><th>Mevcut</th></tr></thead>
            <tbody>{res.rows.map((r) => (
              <tr key={r.user_id} data-testid={`prim-sim-row-${r.user_id}`}><td>{r.name}</td><td className="text-[12px]">{r.method_label}</td>
                <td className="text-right font-mono">{formatTRY(r.totals.eligible_sales)}</td><td className="text-right font-mono">{"margin_pct" in r.totals ? formatPct(r.totals.margin_pct) : "—"}</td>
                <td className="text-right font-mono">{formatTRY(r.totals.lines_prim)}</td><td className="text-right font-mono text-rose-600">{r.totals.adjustments_total ? formatTRY(r.totals.adjustments_total) : "—"}</td>
                <td className="text-right font-mono font-bold">{formatTRY(r.totals.prim_total)}</td><td className="text-[11px]">{r.existing ? `${r.existing.run_no} · ${r.existing.status_label}` : "—"}</td></tr>))}</tbody>
          </table></div>
        )}
      </DialogContent>
    </Dialog>
  );
}
